"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EmeraldNotificationCoreInputs = void 0;
/* eslint-disable @typescript-eslint/no-inferrable-types */
const notification_variant_1 = require("./notification.variant");
class EmeraldNotificationCoreInputs {
    constructor() {
        this.hasAction = false;
        this.actionText = '';
        this.variant = notification_variant_1.EmeraldNotificationVariant.DEFAULT;
        this.dismissible = true;
    }
}
exports.EmeraldNotificationCoreInputs = EmeraldNotificationCoreInputs;
//# sourceMappingURL=notification.inputs.js.map